// The active team's name, shown in the profile-menu trigger beside the avatar.
//
// The team row inside the dropdown (UserMenuTeamSection) was the only place the
// active team appeared, so telling which team you were acting as — and which
// team new projects would land in — meant opening the menu. This puts the name
// on the closed control.
//
// The caller renders this only when `teams_enabled` is on; it reads the flag
// there because both headers already have it. This renders nothing until a team
// has resolved. Hidden below `sm`, where the header row has no room for it; the
// dropdown still shows it.

import { useActiveTeam } from '../../contexts/ActiveTeamContext'

export default function UserMenuActiveTeamLabel() {
  const { activeTeam } = useActiveTeam()

  if (!activeTeam) return null

  return (
    <span
      data-testid="user-menu-trigger-team-name"
      title={activeTeam.name}
      className="hidden max-w-[10rem] truncate px-3 text-sm font-medium text-white/80 sm:block"
    >
      {activeTeam.name}
    </span>
  )
}
